import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

export function animation() {
  // フッター TOPスクロールボタン
  // document.getElementById("js-scrollTop").addEventListener("click", () => {
  //   gsap.to(window, {
  //     duration: 1,
  //     scrollTo: {
  //       y: 0,
  //       autoKill: false,
  //     },
  //   });
  // });

  // フェードインアニメーション
  const fadeInElements = document.querySelectorAll(".js-fade-in");
  fadeInElements.forEach((element) => {
    gsap.fromTo(
      element,
      {
        opacity: 0,
        y: 30,
      },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power4.out",
        scrollTrigger: {
          trigger: element, // トリガーとなる要素を指定
          start: "top 90%", // スクロール開始位置を指定
          //markers: true,
        },
      }
    );
  });

  const fadeInLeftElements = document.querySelectorAll(".js-fade-in-left");
  fadeInLeftElements.forEach((element) => {
    gsap.fromTo(
      element,
      {
        opacity: 0,
        x: -30,
      },
      {
        opacity: 1,
        x: 0,
        duration: 1,
        ease: "power1.out",
        scrollTrigger: {
          trigger: element, // トリガーとなる要素を指定
          start: "top 80%", // スクロール開始位置を指定
          //markers: true,
        },
      }
    );
  });

  const fadeInRightElements = document.querySelectorAll(".js-fade-in-right");
  fadeInRightElements.forEach((element) => {
    gsap.fromTo(
      element,
      {
        opacity: 1,
        x: 100,
      },
      {
        opacity: 1,
        x: 0,
        duration: 1,
        ease: "power4.out",
        scrollTrigger: {
          trigger: element, // トリガーとなる要素を指定
          start: "top 80%", // スクロール開始位置を指定
          //markers: true,
        },
      }
    );
  });



  // フェードイン（遅延付き）アニメーション
  const fadeInDelayElements = document.querySelectorAll(".js-fade-in-delay");
  fadeInDelayElements.forEach((element, index) => {
    gsap.fromTo(
      element,
      {
        opacity: 0,
        y: 30,
      },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        delay: index * 0.3, // インデックスに応じてディレイ
        ease: "power1.out",
        scrollTrigger: {
          trigger: element,
          start: "top 100%",
          // markers: true,
        },
      }
    );
  });



  // スライドイン（時間差）アニメーション
  const slideInItems = document.querySelectorAll(".js-slide-in-item");
  const slideInContainer = document.querySelector(".c-mv__imageItems");
  if (slideInItems.length > 0 && slideInContainer) {
    slideInItems.forEach((element, index) => {
      gsap.fromTo(
        element,
        {
          opacity: 0,
          y: 30, // 下から上へスライド
        },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          delay: index * 0.3, // 時間差（0.2秒ずつ遅延）
          ease: "power2.out",
          scrollTrigger: {
            trigger: slideInContainer,
            start: "top 80%",
            // markers: true,
          },
        }
      );
    });
  }



  /**
   * スライドイン（スタッガー）アニメーション - 複数箇所で使い回し可能
   * @param {Object} options
   * @param {string} options.containerSelector - コンテナのセレクタ（例: ".js-slide-in-stagger-container"）
   * @param {string} options.itemSelector - 子アイテムのセレクタ（例: ".js-slide-in-stagger"）
   * @param {number} [options.y=50] - 開始時の y 位置（下から上へ）
   * @param {number} [options.duration=0.8] - アニメーション時間
   * @param {number} [options.staggerDelay=0.4] - スタッガー間隔（秒）
   * @param {string} [options.triggerStart="top 85%"] - ScrollTrigger の start 位置
   */
  function initSlideInStagger(options) {
    const {
      containerSelector,
      itemSelector,
      y = 50,
      duration = 0.8,
      staggerDelay = 0.4,
      triggerStart = "top 85%",
    } = options;

    const containers = document.querySelectorAll(containerSelector);
    containers.forEach((container) => {
      const items = container.querySelectorAll(itemSelector);
      if (items.length === 0) return;

      items.forEach((element, index) => {
        gsap.fromTo(
          element,
          {
            opacity: 0,
            y,
          },
          {
            opacity: 1,
            y: 0,
            duration,
            delay: index * staggerDelay,
            ease: "power2.out",
            scrollTrigger: {
              trigger: container,
              start: triggerStart,
            },
          }
        );
      });
    });
  }


  
  // スライドイン（1秒スタッガー・下から）アニメーション
  initSlideInStagger({
    containerSelector: ".js-slide-in-stagger-1s-container",
    itemSelector: ".js-slide-in-stagger-1s",
    y: 50,
    duration: 0.8,
    staggerDelay: 0.4,
    triggerStart: "top 85%",
  });



  // スライドインアニメーション（MV用）
  const slideInMvElements = document.querySelectorAll(".js-slideIn-mv");
  slideInMvElements.forEach((element) => {
    gsap.fromTo(
      element,
      {
        opacity: 0,
        y: 30,
      },
      {
        opacity: 1,
        y: 0,
        duration: 2, // 1秒でアニメーション
        delay: 0.5, // 0.3秒遅延
        ease: "power4.out",
        scrollTrigger: {
          trigger: element, // トリガーとなる要素を指定
          start: "top 100%", // スクロール開始位置を指定
          //markers: true,
        },
      }
    );
  });



  // スライドインアニメーション
  const slideInElements = document.querySelectorAll(".js-slideIn");
  slideInElements.forEach((element) => {
    gsap.fromTo(
      element,
      {
        opacity: 0,
        y: 30,
      },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power4.out",
        scrollTrigger: {
          trigger: element, // トリガーとなる要素を指定
          start: "top 90%", // スクロール開始位置を指定
          //markers: true,
        },
      }
    );
  });



  // 画像の下からclip-pathで表示アニメーション（単体）
  const imageFadeUpElements = document.querySelectorAll(".js-image-fade-up");
  imageFadeUpElements.forEach((element) => {
    gsap.fromTo(
      element,
      {
        clipPath: "inset(100% 0 0 0)", // 下から100%隠す
      },
      {
        clipPath: "inset(0% 0 0 0)", // 完全に表示
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: element,
          start: "top 90%", // トリガー位置を遅くする
          //markers: true,
        },
      }
    );
  });



  // 画像の下からclip-pathで表示アニメーション（複数・スタッガー効果）
  const imageFadeUpStaggerElements = document.querySelectorAll(".js-image-fade-up-stagger");
  const imageFadeUpStaggerContainer = document.querySelector(".js-image-fade-up-container");
  if (imageFadeUpStaggerElements.length > 0) {
    // コンテナが指定されている場合はスタッガー効果を適用
    if (imageFadeUpStaggerContainer && imageFadeUpStaggerElements.length > 1) {
      gsap.fromTo(
        imageFadeUpStaggerElements,
        {
          clipPath: "inset(100% 0 0 0)",
        },
        {
          clipPath: "inset(0% 0 0 0)",
          duration: 1,
          ease: "power2.out",
          stagger: 0.3,
          scrollTrigger: {
            trigger: imageFadeUpStaggerContainer,
            start: "top 85%",
            //markers: true,
          },
        }
      );
    } else {
      // 各要素を個別に処理（複数付けても問題ない）
      imageFadeUpStaggerElements.forEach((element) => {
        gsap.fromTo(
          element,
          {
            clipPath: "inset(100% 0 0 0)",
          },
          {
            clipPath: "inset(0% 0 0 0)",
            duration: 1,
            ease: "power4.out",
            scrollTrigger: {
              trigger: element,
              start: "top 70%", // 要素が画面の70%の位置に来た時に発火（より遅く）
              //markers: true,
            },
          }
        );
      });
    }
  }



  // MVが画面から消えたらp-fixをフワッと表示
  const mvElement = document.querySelector(".c-mv");
  const mvLowerElement = document.querySelector(".p-mv-lower");
  const fixElement = document.querySelector(".js-fix");
  const footerElement = document.querySelector(".p-footer");
  const triggerMv = mvElement || mvLowerElement;

  if (triggerMv && fixElement) {
    // 初期状態を非表示に設定
    gsap.set(fixElement, {
      opacity: 0,
    });

    // MVが画面から消えたら表示
    ScrollTrigger.create({
      trigger: triggerMv,
      start: "bottom top",
      onEnter: () => {
        gsap.to(fixElement, {
          opacity: 1,
          y: 0,
          duration: 0.6,
          ease: "power2.out",
        });
      },
      onLeaveBack: () => {
        gsap.to(fixElement, {
          opacity: 0,
          duration: 0.6,
          ease: "power2.out",
        });
      },
    });

    // フッターが画面に入ったらp-fixをフワッと消す
    if (footerElement) {
      ScrollTrigger.create({
        trigger: footerElement,
        start: "top bottom",
        onEnter: () => {
          gsap.to(fixElement, {
            opacity: 0,
            duration: 0.6,
            ease: "power2.out",
          });
        },
        onLeaveBack: () => {
          const mvRect = triggerMv.getBoundingClientRect();
          if (mvRect.bottom < 0) {
            gsap.to(fixElement, {
              opacity: 1,
              y: 0,
              duration: 0.6,
              ease: "power2.out",
            });
          }
        },
      });
    }
  }
}



jQuery(function($) {
  // この中では安全に "$" を使って記述できます
  let winHeight, winScroll, scrollPos;

  $(window).on('load scroll', function() {
    winScroll = $(window).scrollTop();
    winHeight = $(window).height();
    scrollPos = winHeight * 0.9 + winScroll;

    $(".slidein").each(function() {
      // 一度アニメーションが発火したら、その状態を保持（削除しない）
      if ($(this).offset().top <= scrollPos) {
        // p-top-client__itemsセクションだけ.show-leftを追加
        if ($(this).hasClass("p-top-client__items")) {
          $(this).addClass("show-left");
        } else {
          $(this).addClass("show");
        }
      }
      // elseブロックを削除して、上に戻っても削除しないようにする
    });
  });
});